<template>

<div class="videoModal" @click="playedVideo" :name="vidName">
  <span class="youtube-modal-link" @click="showModal = true"><slot></slot></span>
  <transition name="fadeDownBig" mode="out-in">
    <div v-if="showModal" class="video-modal-wrapper">
      <div class="modal-close-btn">
        <span @click="showModal = false">CLOSE</span>
      </div>
      <div class="video-embed-wrapper">
      <transition name="bounce" mode="out-in">
       <iframe width="100%" height="100%" :src="vidUrl"  frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </transition>
      </div>
    </div>
  </transition>
</div>

</template>

<script>

export default {
  name: 'VideoModal',
    props: {
      button: '',
      vidUrl: '',
      vidName: ''
  },
  data: function () {
    return {
      showModal: false
  }
},
methods: {
  playedVideo() {
      this.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Clicked the Video Link',
        eventLabel: this.vidName,
        eventValue: '1'
      })
    },
}

}

</script>

<style>

.videoModal {
    display: inline;
    cursor:pointer;

}

.videoModal > span {
    border-bottom: 3px solid #D3BC8D;
    transition-duration: .25s;
}
.videoModal > span:hover {
    background: #D3BC8D;
    transition-duration: .25s;
}


.video-modal-wrapper{
background-color:rgba(0, 0, 0, 0.9);
width:100%;
min-height:100vh;
height:100%;
position:fixed;
display:flex;
justify-content:center;
align-items:center;
top: 0;
    left: 0;
    z-index: 10;
}

.video-embed-wrapper {
    width: 1280px;
    height: 720px;
    box-shadow: 0 0 450px -70px #dbcb90;
}

.modal-close-btn {
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 50px;
    line-height: 50px;
    padding: 0px 10px;
    color: white;
    border-bottom: 5px solid white;
    cursor: pointer;
    background: #d2bc8d;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn-close {
    content: 'close';
    position: fixed;
    top: 10px;
    right: 10px;
    text-transform: uppercase;
    font-size: 44px;
    font-weight: bold;
    color: white;
}

.video-modal-inner{

}

@media (max-width:1366px) {

.video-embed-wrapper {
    width: 1066.666666px;
    height: 600px;
}

}

@media (max-width:1024px) {

.video-embed-wrapper {
    width: 853.33333333px;
    height: 423.5294117647059px;
}

.modal-close-btn {
    font-size: 35px;
    line-height: 45px;
}

}

@media (max-width:1023px) {

.video-embed-wrapper {
    width: 100%;
    height: 320px;
    padding: 30px;
}

}

@media (max-width:667px) {

.modal-close-btn {
    font-size: 24px;
    line-height: 40px;
}

}


@media (max-width:420px) {

.video-embed-wrapper {
    width: 100%;
    height: 220px;
}

}


</style>


// WEBPACK FOOTER //
// src/components/VideoBtn.vue